import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";
import RoomCalendarCard from "./QuarterlyTargetPlanCard";
import QuarterlyTargetPlanCard from "./QuarterlyTargetPlanCard";
import { Box, Typography } from "@mui/material";

const QuarterlyTargetPlanData = ({ getNextData }) => {
  const { quarterlyData, loading } = useSelector(
    (state) => state.quarterlyTargetPlanData,
  );

  const mockData = [
    {
      course: {
        _id: "659948c281735e454cc1888d",
        name: "Front-end",
      },
      newGroupName: "testest01",
      startDate: "2025-12-07T20:00:00.000Z",
      endDate: "2026-01-10T19:59:59.999Z",
      mainDateData: {
        days: [1, 4],
        hour: {
          start: "15:00",
          end: "18:00",
        },
        suitableMainLessonRooms: [
          {
            _id: "669cbef7445b870c8cea6136",
            name: "UX/UI",
            groups: [
              {
                group: "68a3230026a9f0ba4b2f728b",
                _id: "68a3230026a9f0ba4b2f7292",
              },
            ],
            __v: 2,
            orderNumber: 3,
          },
          {
            orderNumber: 1,
            _id: "669cc3cfea3ea5f5c3e96859",
            name: "S",
            groups: [],
            __v: 0,
          },
        ],
        suitableTeachers: [
          {
            _id: "69145a43ddb3ce8158444cce",
            fullName: "Topush",
            email: "top@gmail.com",
            password: "",
            fin: "topush",
            seria: "XXXXXXXX",
            courses: [
              {
                course: {
                  _id: "65f2ef2deb79104572b22ad6",
                  name: "React Native",
                  payments: [
                    {
                      paymentType: "Tam",
                      part: 13,
                      payment: 12323,
                      _id: "65f2ef2deb79104572b22ad7",
                    },
                  ],
                  createdAt: "2024-03-14T12:35:57.117Z",
                  updatedAt: "2024-11-22T09:37:46.428Z",
                  __v: 0,
                  deleted: false,
                },
                salary: 0,
                _id: "69368ac342a02ab49df0566e",
              },
            ],
            status: true,
            role: "teacher",
            phone: "xxxxxxxxxx",
            birthday: "2025-11-04T20:00:00.000Z",
            deleted: false,
            createdAt: "2025-11-12T09:58:27.649Z",
            updatedAt: "2025-12-08T08:22:27.846Z",
            __v: 0,
          },
          {
            _id: "6842a7ba6ed53b6234231fc6",
            fullName: "Nicat Memmedli",
            email: "nicat@bda.edu.az",
            password: "",
            fin: "58GJBEA",
            seria: "AA1234567",
            courses: [
              {
                course: {
                  _id: "65f2ef2deb79104572b22ad6",
                  name: "React Native",
                  payments: [
                    {
                      paymentType: "Tam",
                      part: 13,
                      payment: 12323,
                      _id: "65f2ef2deb79104572b22ad7",
                    },
                  ],
                  createdAt: "2024-03-14T12:35:57.117Z",
                  updatedAt: "2024-11-22T09:37:46.428Z",
                  __v: 0,
                  deleted: false,
                },
                salary: 0,
                _id: "69368acf42a02ab49df05693",
              },
            ],
            status: true,
            role: "teacher",
            phone: "XXXXXXXXX",
            birthday: "2025-06-05T20:00:00.000Z",
            deleted: false,
            createdAt: "2025-06-06T08:32:59.131Z",
            updatedAt: "2025-12-08T08:22:39.324Z",
            __v: 0,
          },
        ],
      },
      labDateData: {
        days: [3],
        hour: {
          start: "10:00",
          end: "12:00",
        },
        suitableLabLessonRooms: [
          {
            orderNumber: 1,
            _id: "670cf5d00f6119a281cd0247",
            name: "4 M",
            groups: [],
            __v: 0,
          },
          {
            orderNumber: 1,
            _id: "669cc67ddad7723bb4df3ab8",
            name: "t",
            groups: [],
            __v: 0,
          },
          {
            orderNumber: 1,
            _id: "669cc6a3dad7723bb4df3ac4",
            name: "Z",
            groups: [],
            __v: 0,
          },
        ],
        suitableMentors: [
          {
            _id: "65e03ddcbd45da70cbba2900",
            fullName: "Kamal Mamedov",
            email: "kamal@gmail.com",
            password: "",
            fin: "124324",
            seria: "242342",
            courses: [],
            status: true,
            role: "mentor",
            phone: "2423423",
            birthday: "1990-12-29T00:00:00.000Z",
            deleted: false,
            createdAt: "2024-02-29T08:18:36.200Z",
            updatedAt: "2025-11-20T11:24:59.645Z",
            __v: 0,
          },
          {
            _id: "65b7673c9f7b46f9e8aaef75",
            fullName: "Ilkin",
            email: "test6@gmail.com",
            password: "",
            fin: "45243",
            seria: "12341234",
            courses: [],
            status: true,
            role: "mentor",
            phone: "234124",
            birthday: "2024-01-16T00:00:00.000Z",
            deleted: false,
            createdAt: "2024-01-29T08:52:13.009Z",
            updatedAt: "2025-11-19T16:41:27.605Z",
            __v: 0,
          },
          {
            _id: "65b75da5bba7b4bb741ae021",
            fullName: "Elmira Ramazanova",
            email: "test1@gmail.com",
            password: "",
            fin: "341114",
            seria: "134341",
            courses: [],
            status: true,
            role: "mentor",
            phone: "98454",
            birthday: "2024-01-29T00:00:00.000Z",
            deleted: false,
            createdAt: "2024-01-29T08:11:18.052Z",
            updatedAt: "2025-11-19T16:41:27.605Z",
            __v: 0,
          },
        ],
      },
    },
    {
      course: {
        _id: "659948c281735e454cc1888d",
        name: "Front-end",
      },
      newGroupName: "testest01",
      startDate: "2025-12-07T20:00:00.000Z",
      endDate: "2026-01-10T19:59:59.999Z",
      mainDateData: {
        days: [1, 4],
        hour: {
          start: "15:00",
          end: "18:00",
        },
        suitableMainLessonRooms: [
          {
            orderNumber: 1,
            _id: "68d9318ebb3171f1a81057b6",
            name: "Grafik",
            __v: 0,
          },
        ],
        suitableTeachers: [],
      },
      labDateData: {
        days: [3],
        hour: {
          start: "19:00",
          end: "21:00",
        },
        suitableLabLessonRooms: [
          {
            orderNumber: 1,
            _id: "669cc676dad7723bb4df3ab5",
            name: "R",
            groups: [],
            __v: 0,
          },
        ],
        suitableMentors: [],
      },
    },
  ];

  const { user } = useSelector((state) => state.user);

  const [scrollHeight, setScrollHeight] = useState(1);

  const tableHead = [
    { id: 1, label: "Fənn" },
    { id: 2, label: "Yeni qrup" },
    { id: 5, label: "Dərs günləri" },
    { id: 6, label: "Dərs saatları" },
    { id: 7, label: "Uyğun Otaqlar" },
    { id: 8, label: "Uyğun Müəllimlər" },
    { id: 9, label: "Uyğun Tyutorlar" },
    { id: 10, label: "Başlama tarixi" },
    { id: 11, label: "Bitmə tarixi" },
    { id: 11, label: "Məlumatların təsdiqi" },
  ];

  useEffect(() => {
    const mainHeader = document.querySelector(".main-header");
    const detailsHeader = document.querySelector(".details-header");

    const handleResize = () => {
      setScrollHeight(
        window.innerHeight -
          mainHeader.offsetHeight -
          detailsHeader.offsetHeight,
      );
    };

    setScrollHeight(
      window.innerHeight - mainHeader.offsetHeight - detailsHeader.offsetHeight,
    );

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Box sx={{ overflowX: "scroll", height: "80vh" }}>
      <Box
        sx={{
          minWidth: "1580px",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            position: "sticky",
            top: "0px",
            zIndex: 1,
          }}
        >
          {tableHead.map((head, i) => (
            <Box
              key={i}
              sx={{
                fontSize: "16px",
                width:
                  i === 0 || i === 2 || i === 3 || i === 9
                    ? "130px"
                    : i === 1
                      ? "100px"
                      : i === 7 || i === 8
                        ? "180px"
                        : "200px",
                display: "flex",
                alignItems: "center",
                border: "1px solid lightgray",
                padding: "10px",
                boxSizing: "border-box",
                backgroundColor: "white",
              }}
            >
              <Typography sx={{ fontSize: "16px" }}> {head.label}</Typography>
            </Box>
          ))}
        </Box>

        <Box>
          {(!loading &&
            quarterlyData?.map((data, i) => (
              <QuarterlyTargetPlanCard
                key={i}
                data={data}
                mode="desktop"
                cellNumber={i + 1}
              />
            ))) || (
            <div style={{ width: "100vw", alignItems: "center" }}>
              <SmallLoading />
            </div>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default QuarterlyTargetPlanData;
